/**
 * @generated SignedSource<<2535394b6d97dc17192004697fc87523>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PipelineRunPagePipelineQuery$variables = {
  locator: string;
};
export type PipelineRunPagePipelineQuery$data = {
  readonly pipeline: {
    readonly " $fragmentSpreads": FragmentRefs<"PipelineRunHeaderFragment">;
  } | null | undefined;
};
export type PipelineRunPagePipelineQuery = {
  response: PipelineRunPagePipelineQuery$data;
  variables: PipelineRunPagePipelineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineRunPagePipelineQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PipelineRunHeaderFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PipelineRunPagePipelineQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BuildTypeRest",
            "kind": "LinkedField",
            "name": "headBuildType",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectId",
                "storageKey": null
              },
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalId",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6a54eefe9d9c8fe71acc5858ef870deb",
    "id": null,
    "metadata": {},
    "name": "PipelineRunPagePipelineQuery",
    "operationKind": "query",
    "text": "query PipelineRunPagePipelineQuery(\n  $locator: String!\n) {\n  pipeline(pipelineLocator: $locator) {\n    ...PipelineRunHeaderFragment\n    _id\n  }\n}\n\nfragment PipelineRunHeaderFragment on PipelineRest {\n  id\n  headBuildType {\n    projectId\n    id\n    internalId\n    ...SaveChangesFragment\n    _id\n  }\n}\n\nfragment SaveChangesFragment on BuildTypeRest {\n  id\n  projectId\n}\n"
  }
};
})();

(node as any).hash = "d0ab9dbc2da4f52542fce7c8b680ec61";

export default node;
